import Swiper, { Navigation } from "swiper";

const ArticleSlider = function () {

    Swiper.use([Navigation]);

    const sections = document.querySelectorAll( '.article-slider' );

    const loadArticles = function( container, data ){
        const articleContainer = container.querySelector( '[data-article-container]' );
        if( typeof( data.tags ) !== 'undefined'){
            const url = data.url.replace( 'tags' , data.tags  );
            fetch( url )
            .then( res => {
                if( res.ok ){
                    return res.text();
                }
                return false;
            })
            .then( text => {
                if( text ){
                    articleContainer.innerHTML = text;
                }else{
                    // articleContainer.parentNode.removeChild( container )
                }

                const swiperEl = container.querySelector( '.swiper' );
                const prevEl = container.querySelector( '.swiper-button-prev' );
                const nextEl = container.querySelector( '.swiper-button-next' );
                const swiper = new Swiper(swiperEl, {
                    slidesPerView: 1.1,
                    spaceBetween: 8,
                    navigation: {
                        nextEl,
                        prevEl
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2.1,
                            spaceBetween: 8,
                        },
                        992: {
                            slidesPerView: 3.3,
                            spaceBetween: 32,
                        },
                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 32,
                        },
                    }
                })
            })
        }
    }

    for (const section of sections) {

        const tabContainers = section.querySelectorAll( '[data-tab-content]' );

        const tabs = section.querySelectorAll( '[data-tab]' );
        tabs.forEach( function( tab ){
            tab.addEventListener( 'click', function( e ){
                e.preventDefault();
                tabs.forEach( function( tab ){
                    tab.classList.remove( 'active' );
                });
                tab.classList.add( 'active' );
                const target = tab.dataset.tab;
                tabContainers.forEach( function( tabContainer ){
                    tabContainer.classList.remove( 'active' );
                    if( tabContainer.dataset.tabContent === target ){
                        tabContainer.classList.add( 'active' );
                    }
                });
            });
        });

        if (tabs.length > 1) {
            const tabSwiperEl = section.querySelector( '.tab-swiper' );
            const tabSwiper = new Swiper(tabSwiperEl, {
                slidesPerView: 'auto',
                spaceBetween: 24,
                watchOverflow: true,
                breakpoints: {
                    576: {
                        spaceBetween: 32,
                    }
                }
            })
        }

        tabContainers.forEach( function( tabContainer ){
            loadArticles( tabContainer, tabContainer.dataset );
        });
    }

}
  
export default ArticleSlider